/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Practice } from './practice';
import { GenderEnum } from './genderEnum';
import { TherapistProfileSerializerMinimal } from './therapistProfileSerializerMinimal';


/**
 * Lightweight patient serializer for autocomplete dropdowns.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientAutocomplete { 
    readonly id: number;
    patientId: string;
    firstName?: string;
    lastName?: string;
    gender: GenderEnum;
    organizations: Array<string>;
    readonly practice: Practice | null;
    readonly assignedTherapist: TherapistProfileSerializerMinimal | null;
}
export namespace PatientAutocomplete {
}

export const PatientAutocomplete_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAutocomplete_patientId_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(7),];

export const PatientAutocomplete_firstName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const PatientAutocomplete_lastName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const PatientAutocomplete_gender_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAutocomplete_organizations_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAutocomplete_practice_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientAutocomplete_assignedTherapist_Validators: ValidatorFn[] =
    [  Validators.required, ];


